<div class="pdf-card">
  <div class="pdf-card-header" [ngClass]="{ 'small-height': smallHeight }">
    <h3 class="pdf-title">{{ title }}</h3>
  </div>

  <div class="pdf-card-body">
    <img
      [src]="thumbnailUrl"
      [alt]="title + ' thumbnail'"
      class="pdf-thumbnail"
    />
  </div>

  <div class="pdf-card-footer">
    <button type="button" class="view-pdf-btn" (click)="openLightbox()">
      View Board
    </button>
  </div>
</div>
